import md5 from 'md5'
let Base = require('js-base64').Base64;
// import Base64 from 'Base64'
export function getRequest(data) {
    var param = ''
    if (typeof data == 'object') {
        for (var i in data) {
            if (typeof data[i] == 'object') {
                var k = data[i]
                for (var j in k) {
                    for (var t in k[j]) {
                        var num = k[j]
                        if (typeof num[t] == 'object') {
                            for (var j = 0; j < num[t].length; j++) {
                                param += num[t][j]
                            }
                        } else {
                            param = param + num[t]
                        }
                    }
                    // param = param + k[j]
                }
            }
            else {
                param = param + data[i]
            }
        }
    } else {
        if (data != undefined) {
            param = data;
        }
    }
    var time = new Date().getTime()
    var key = process.env.SECRET_KEY
    var str = 'CBNWeeklyAPI'
    var sign = md5(key + decodeURI(param) + str)
    var Bases = Base.encode(sign)
    return Bases
}




// WEBPACK FOOTER //
// ./src/utils/postData.js